import React, { useState, useEffect } from "react";
import NavigationBar from "../NavigationBar/NavigationBar";
import LogoutButton from "../LogoutButton/LogoutButton";
import HamburgerMenu from "../HamburgerMenu/HamburgerMenu";
import "./SideBar.css";

const Sidebar = ({ 
  setActiveForm, 
  showLastThree, 
  onLogout, 
  onHamburgerToggle, 
  isHamburgerOpen, 
  setIsHamburgerOpen,
  setTitle
 }) => {
    const [buttonClicked, setButtonClicked] = useState(false);
  
    useEffect(() => {
        if (buttonClicked) {
          setIsHamburgerOpen(false);
          setButtonClicked(false); 
        }
      }, [buttonClicked, setIsHamburgerOpen]);
      
    
    const handleHamburgerToggle = () => {
      if (buttonClicked) {
        setButtonClicked(false);
      } else {
        onHamburgerToggle();
      }
    };
  
   
    return (
      <div className="sidebar-container">
        <HamburgerMenu isOpen={isHamburgerOpen} onToggle={handleHamburgerToggle} />
        <div className={`sidebar ${isHamburgerOpen ? "sidebar-open" : "sidebar-closed"}`}>
          <div>
            <NavigationBar 
            setActiveForm={setActiveForm}
             showLastThree={showLastThree} 
             setButtonClicked={setButtonClicked}
             setTitle={setTitle}
              />
          </div>
          <div>
            <LogoutButton onLogout={onLogout} />
          </div>
        </div>
      </div>
    );
};

export default Sidebar;